import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Icon, Menu } from '@percent/lemonade'
import { FundraisersMenuProps } from './FundraisersMenu.types'

export function FundraisersMenu({
  fundraiser,
  fundraiserUrl,
  openFundraiserModal,
  openReopenFundraiserModal,
  userCan,
  openFeaturedFundraiserModal,
  openRemoveFeaturedFundraiserModal
}: FundraisersMenuProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const editFundraiserUrl = `${fundraiserUrl}/edit`

  const menuItems = [
    { key: 'view', label: t('dialog.fundraisers.view') },
    ...(userCan('manageFundraisers') && fundraiser.status !== 'closed'
      ? [
          {
            key: 'edit',
            label: t('dialog.fundraisers.edit')
          },
          {
            key: 'close',
            label: t('dialog.fundraisers.close')
          },
          {
            key: fundraiser.featured ? 'removeFeaturedFundraiser' : 'featureFundraiser',
            label: t(fundraiser.featured ? 'dialog.fundraisers.remove' : 'dialog.fundraisers.feature.title'),
            withSeparator: true
          }
        ]
      : []),
    ...(userCan('manageFundraisers') && fundraiser.status === 'closed'
      ? [
          {
            key: 'reopen',
            label: t('dialog.fundraisers.reopen')
          }
        ]
      : []),

    {
      key: 'viewDonations',
      label: t('dialog.fundraisers.viewDonations'),
      withSeparator: true
    }
  ]

  const handleMenuSelect = (actionKey: string) => {
    switch (actionKey) {
      case 'view':
        window.open(fundraiserUrl, '_blank', 'noopener noreferrer')
        break
      case 'edit':
        window.open(editFundraiserUrl, '_blank', 'noopener noreferrer')
        break
      case 'close':
        openFundraiserModal(fundraiser)
        break
      case 'reopen':
        openReopenFundraiserModal(fundraiser)
        break
      case 'featureFundraiser':
        openFeaturedFundraiserModal({ id: fundraiser.id, title: fundraiser.page.title })
        break
      case 'removeFeaturedFundraiser':
        openRemoveFeaturedFundraiserModal({
          featuredItemId: fundraiser.featured?.featuredItemId,
          title: fundraiser.page.title
        })
        break
      case 'viewDonations':
        navigate(`/workplace-giving/fundraisers/${fundraiser.id}`)
        break
      default:
        // eslint-disable-next-line no-console
        console.warn(`Unhandled action: ${actionKey}`)
    }
  }

  return (
    <Menu
      title={<Icon name="menu-vertical" size={6} />}
      sections={[
        {
          items: menuItems
        }
      ]}
      onSelect={handleMenuSelect}
    />
  )
}
